// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';

import SportRadarPlayerWidget from './SportRadarPlayerWidget';
import selectSportRadarPlayerWidgetProps from './SportRadarPlayerWidget.selector';

type SportRadarPlayerWidgetProps = {
  playerSrId: number;
  matchId: number;
  playerTeam: 1 | 2;
};

const SportRadarPlayerWidgetContainer = ({ playerTeam: teamId, matchId, ...ownProps }: SportRadarPlayerWidgetProps) => {
  const selectorProps = useMemo(() => ({ matchId, teamId }), [matchId, teamId]);
  const selectedProps = useSelector((state) => selectSportRadarPlayerWidgetProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <SportRadarPlayerWidget {...enhancedProps} />;
};

export default SportRadarPlayerWidgetContainer;
